import { Aux } from './AuxillaryServices';

function getScreenshot(callback) {
    var reqId = Math.random().toString(); // unique ID for this request
    var dataObj = { reqId: reqId };
    var screenyEvent = new CustomEvent('screeny', { detail: dataObj });

    // get ready for a reply from the content script
    document.addEventListener('fetchResponse', function respListener(event) {
        var data = event.detail;

        // check if this response is for this request
        if (data.reqId == reqId) {
            callback(data.dataUrl);
            document.removeEventListener('fetchResponse', respListener);
        }
    });

    document.dispatchEvent(screenyEvent);
}

function getScreenyVersion(callback) {
    try {
        var reqId = Math.random().toString(); // unique ID for this request
        var dataObj = { reqId: reqId };
        var screenyEvent = new CustomEvent('screenyVersion', { detail: dataObj });

        var interval;

        var respListener = function (event) {
            var data = event.detail;

            // check if this response is for this request
            if (data.reqId == reqId) {
                clearTimeout(interval);
                callback(data.version);
                document.removeEventListener('fetchResponse', respListener);
            }
        };

        interval = setTimeout(function () {
            document.removeEventListener('fetchResponse', respListener);
            callback(null);
        }, 250);

        // get ready for a reply from the content script
        document.addEventListener('fetchResponse', respListener);

        document.dispatchEvent(screenyEvent);
    } catch (ex) {
        callback(null);
    }
}

function ScreenshotDisabled() {
    this.getScreenshot = function (callback) {
        callback(null);
    };
}

function ScreenshotFromExtension() {
    this.getScreenshot = function (callback) {
        getScreenshot(function (dataUrl) {
            callback(dataUrl);
        });
    };
}

function ScreenshotBase() {}

ScreenshotBase.m_Loaded = false;

ScreenshotBase.onServiceDiscovered = function (event) {
    switch (event) {
        case 'Initialize': {
            Aux.RegisterService('Screenshot', new ScreenshotDisabled());

            getScreenyVersion(function (version) {
                if (null !== version) {
                    Aux.RegisterService('Screenshot', new ScreenshotFromExtension());
                }
            });

            break;
        }
    }
};

/**
 * @todo document this
 */
function initializeScreenshot() {
    Aux.AddListener(ScreenshotBase.onServiceDiscovered);

    //pollyfill for btoa
    if (!btoa) {
        /**
         *
         *  Base64 encode / decode
         *  http://www.webtoolkit.info/
         *
         **/
        var Base64 = {
            // private property
            _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
            // public method for encoding
            encode: function (input) {
                var output = '';
                var chr1;
                var chr2;
                var chr3;
                var enc1;
                var enc2;
                var enc3;
                var enc4;
                var i = 0;

                input = Base64._utf8_encode(input);

                while (i < input.length) {
                    chr1 = input.charCodeAt(i++);
                    chr2 = input.charCodeAt(i++);
                    chr3 = input.charCodeAt(i++);

                    enc1 = chr1 >> 2;
                    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                    enc4 = chr3 & 63;

                    if (isNaN(chr2)) {
                        enc3 = enc4 = 64;
                    } else if (isNaN(chr3)) {
                        enc4 = 64;
                    }

                    output =
                        output +
                        this._keyStr.charAt(enc1) +
                        this._keyStr.charAt(enc2) +
                        this._keyStr.charAt(enc3) +
                        this._keyStr.charAt(enc4);
                }

                return output;
            },
            // public method for decoding
            decode: function (input) {
                var output = '';
                var chr1;
                var chr2;
                var chr3;
                var enc1;
                var enc2;
                var enc3;
                var enc4;
                var i = 0;

                input = input.replace(/[^A-Za-z0-9+/=]/g, '');

                while (i < input.length) {
                    enc1 = this._keyStr.indexOf(input.charAt(i++));
                    enc2 = this._keyStr.indexOf(input.charAt(i++));
                    enc3 = this._keyStr.indexOf(input.charAt(i++));
                    enc4 = this._keyStr.indexOf(input.charAt(i++));

                    chr1 = (enc1 << 2) | (enc2 >> 4);
                    chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                    chr3 = ((enc3 & 3) << 6) | enc4;

                    output = output + String.fromCharCode(chr1);

                    if (enc3 != 64) {
                        output = output + String.fromCharCode(chr2);
                    }
                    if (enc4 != 64) {
                        output = output + String.fromCharCode(chr3);
                    }
                }

                output = Base64._utf8_decode(output);

                return output;
            },

            // private method for UTF-8 encoding
            _utf8_encode: function (string) {
                string = string.replace(/\r\n/g, '\n');
                var utftext = '';

                for (var n = 0; n < string.length; n++) {
                    var c = string.charCodeAt(n);

                    if (c < 128) {
                        utftext += String.fromCharCode(c);
                    } else if (c > 127 && c < 2048) {
                        utftext += String.fromCharCode((c >> 6) | 192);
                        utftext += String.fromCharCode((c & 63) | 128);
                    } else {
                        utftext += String.fromCharCode((c >> 12) | 224);
                        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                        utftext += String.fromCharCode((c & 63) | 128);
                    }
                }

                return utftext;
            },

            // private method for UTF-8 decoding
            _utf8_decode: function (utftext) {
                var string = '';
                var i = 0;
                var c2;
                var c3;
                var c = (c2 = 0);

                while (i < utftext.length) {
                    c = utftext.charCodeAt(i);

                    if (c < 128) {
                        string += String.fromCharCode(c);
                        i++;
                    } else if (c > 191 && c < 224) {
                        c2 = utftext.charCodeAt(i + 1);
                        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                        i += 2;
                    } else {
                        c2 = utftext.charCodeAt(i + 1);
                        c3 = utftext.charCodeAt(i + 2);
                        string += String.fromCharCode(
                            ((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)
                        );
                        i += 3;
                    }
                }

                return string;
            },
        };

        // eslint-disable-next-line no-global-assign
        btoa = function (text) {
            return Base64.encode(text);
        };
    }
}

export { initializeScreenshot };
